import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import Home from '@/pages/home/Home'
import Bookshelf from '@/pages/bookshelf/Bookshelf'
import Myaccount from '@/pages/account/Myaccount'
import Login from '@/pages/account/Login'
import Categry from '@/pages/categry/Categry'
import Recommend from '@/pages/recommend/Recommend'
import Theme from '@/pages/theme/Theme'
import dzDetail from '@/pages/detail/dzDetail'
import ysDetail from '@/pages/detail/ysDetail'
import qkDetail from '@/pages/detail/qkDetail'
import Search from '@/pages/search/Search'
import Register from '@/pages/account/Register'
import Cipher from '@/pages/account/Cipher'
import FootPrint from '@/pages/footprint/FootPrint'
import BookJy from '@/pages/bookjy/BookJy'
import ErrorPage from '@/common/error'
import AuthLogin from '@/pages/account/AuthLogin'
import EmptyPage from '@/common/Empty'
import { Form } from 'element-ui'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/bookshelf',
      name: 'Bookshelf',
      component: Bookshelf,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/account',
      name: 'Myaccount',
      component: Myaccount,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/cipher',
      name: 'Cipher',
      component: Cipher,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/categry',
      name: 'Categry',
      component: Categry
    },
    {
      path: '/recommend/:id',
      name: 'Recommend',
      component: Recommend
    },
    {
      path: '/theme/:id',
      name: 'Theme',
      component: Theme
    },
    {
      path: '/categry/:id',
      name: 'Categry',
      component: Categry
    },
    {
      path: '/detail/dzDetail/:id',
      name: 'dzDetail',
      component: dzDetail
    },
    {
      path: '/detail/ysDetail/:id',
      name: 'ysDetail',
      component: ysDetail
    },
    {
      path: '/detail/qkDetail/:id',
      name: 'qkDetail',
      component: qkDetail
    },
    {
      path: '/Search',
      name: 'Search',
      component: Search
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/AuthLogin',
      name: 'AuthLogin',
      component: AuthLogin
    },
    {
      path: '/Register',
      name: 'Register',
      component: Register
    },
    {
      path: '/footprint',
      name: 'FootPrint',
      component: FootPrint,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/bookjy',
      name: 'BookJy',
      component: BookJy,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/error',
      name: 'error',
      component: ErrorPage,
    },
    {
      path: '/empty',
      name: 'empty',
      component: EmptyPage,
    },
  ],
scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  // 判断该路由是否需要登录权限
  if (to.meta.requireAuth) {
    // 通过vuex state获取当前的token是否存在
    if (window.localStorage.Token && window.localStorage.Token.length >= 128) {
      if (JSON.parse(localStorage.getItem("OrgInfo")).Id === '3058') {
        if (to.path === '/login') {
          next({
            path: '/',
            query: { redirect: to.fullPath }// 将跳转的路由path作为参数，登录成功后跳转到该路由
          })
        }else{
          next();
        }
      }else{
        next();
      }
    } else {
      next({
        path: '/login',
        query: { redirect: to.fullPath }// 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  } else {
    if (localStorage.getItem("OrgInfo") === null || localStorage.getItem("OrgInfo") === undefined) {
      axios.post('Center/GetOrgInfoFromDomain?domain='+ document.domain).then((r) =>{
        if (r.data.code == 1) {
          localStorage.setItem("OrgInfo", JSON.stringify(r.data.data))
          if (JSON.parse(localStorage.getItem("OrgInfo")).Id === '3058') {
            if (to.path === '/login') {
              next({
                path: '/',
                query: { redirect: to.fullPath }// 将跳转的路由path作为参数，登录成功后跳转到该路由
              })
            }else{
              next();
            }
          }else{
            next();
          }
        }
      })
    }else{
      if (JSON.parse(localStorage.getItem("OrgInfo")).Id === '3058') {
        if (to.path === '/login') {
          next({
            path: '/',
            query: { redirect: to.fullPath }// 将跳转的路由path作为参数，登录成功后跳转到该路由
          })
        }else{
          next();
        }
      }else{
        next();
      }
      // next();
    }
  }
})



router.selfaddRoutes = function (params) {
  router.matcher = new router().matcher;
  router.routes(params)
}

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js